import $ from 'jquery';
import Chart from 'chart.js/auto';

/*
 * Chart manager
 */
export class Graph {
  graphs = {};
  project_title = '';

  constructor() {
    if ($('.graphs').length === 0) return;

    Graph.project_title = $('.graphs').data('projectTitle');

    let lastrisk;

    $('.graph-select').on('change', async (event) => {
      const type = $(event.target).parents('.graph').data('type');
      const key = $(event.target).data('key');

      if (key == 'measure') lastrisk = $('[data-key=\'risk\']').val();

      if (!this.graphs[type]) this.graphs[type] = {};
      if (!this.graphs[type].parameters) this.graphs[type].parameters = {};
      this.graphs[type].parameters[key] = $(event.target).val();

      this.showLoading(type);

      //if (['danger', 'measure'].includes(key)) await this.updateriskSelect(type);

      /*if (key == 'measure') {
        $('[data-key=\'risk\']').val(lastrisk).trigger('change');
        return;
      }*/

      this.updateGraphic(type);
    });

    $('.graph-export').on('click', (event) => {
      event.preventDefault();

      const type = $(event.target).parents('.graph').data('type');

      this.graphs[type].chart.exportToImage();
    });

    $('.graph').each((index, element) => {
      const type = $(element).data('type');
      const title = $(element).find('h2').text();

      if (!this.graphs[type]) this.graphs[type] = {
        element: $(element)
      };

      if (type === 'objects-summary') {
        this.graphs[type].parameters = {
          _danger: $(element).find('.graph-select[data-key="_danger"]').val(),
          measure: $(element).find('.graph-select[data-key="measure"]').val(),
          risk: $(element).find('.graph-select[data-key="risk"]').val()
        };

        this.graphs[type].chart = new ObjectsSummaryChart($(element).find('canvas'), type, title);
      }

      if (type === 'cost-summary') this.graphs[type].chart = new CostSummaryChart($(element).find('canvas'), type, title);

      if (type === 'collective-risk') {
        this.graphs[type].parameters = {
          measure: $(element).find('.graph-select[data-key="measure"]').val(),
        };

        this.graphs[type].chart = new CollectiveRiskChart($(element).find('canvas'), type, title);
      }

      this.updateGraphic(type);
    });

    $(window).on('resize', () => {
      $('.graph').each((index, element) => {
        const type = $(element).data('type');

        this.graphs[type].chart.resize();
      });
    });
  }

  async updateriskSelect(type) {
    const parameters = this.graphs[type].parameters;
    if (!parameters._danger || !parameters.measure) return;

    const ristkTypeSelect = $(`.graph[data-type="${type}"] .graph-select[data-key="risk"]`);

    ristkTypeSelect.find('option:not(:disabled)').remove();
    ristkTypeSelect.val(0).attr('disabled', 'disabled');
    parameters.risk = 0;
    this.graphs[type].chart.clear();

    await $.ajax({
      url: ajaxurlobject,
      type: 'GET',
      data: {
        ...{ 'action': 'graph_get_risk_types' },
        ...parameters
      },
      dataType: 'json',
      success: function (response) {
        response.forEach((risk) => {
          ristkTypeSelect.removeAttr('disabled');

          ristkTypeSelect.append(`<option value="${risk.value}">${risk.title}</option>`);
        });
      }
    });
  }

  updateGraphic(type) {
    const parameters = this.graphs[type].parameters;

    if (type === 'objects-summary' && (!parameters._danger || !parameters.measure || !parameters.risk)) return;

    this.showLoading(type);

    let unit = '';
    if (type === 'objects-summary') {
      unit = $(this.graphs[type].element).find('.graph-select[data-key="risk"] option:selected').data('unit');
    } else {
      unit = $(this.graphs[type].element).data('unit');
    }

    this.graphs[type].chart.unit = unit;

    $.ajax({
      url: ajaxurlobject,
      type: 'GET',
      data: {
        ...{
          'action': 'graph_get_data',
          'type': type
        },
        ...parameters
      },
      dataType: 'json',
      success: (response) => {
        this.graphs[type].chart.update(response);
        this.hideLoading(type);
      }
    });
  }

  showLoading(type) {
    this.graphs[type].element.find('canvas').addClass('invisible');
    this.graphs[type].element.find('.spinner').removeClass('d-none');
  }

  hideLoading(type) {
    this.graphs[type].element.find('canvas').removeClass('invisible');
    this.graphs[type].element.find('.spinner').addClass('d-none');
  }
}

/*
 * Chart plugins
 */
const backgroundPlugin = {
  id: 'customCanvasBackgroundColor',
  beforeDraw: (chart, args, options) => {
    const { ctx } = chart;
    ctx.save();
    ctx.globalCompositeOperation = 'destination-over';
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, chart.width, chart.height);
    ctx.restore();
  }
};

/*
 * Chart classes
 */
class SingleChart {
  element = null;
  type = null;
  chartObject = null;
  configuration = null;
  unit = '';

  constructor(element, type, title = '', unit = '') {
    this.element = element;
    this.type = type;
    this.title = this.fulltitle = title;

    this.configuration = {
      data: {
        labels: [],
        datasets: []
      },
      responsive: true,
      options: {
        plugins: {
          title: {
            display: true,
            text: title,
          },
          tooltip: {
            callbacks: {
              label: (context) => {
                return this.unitLabelCallback(context, this.unit, this.type)
              }
            }
          }
        }
      },
      plugins: [backgroundPlugin]
    };
  }

  unitLabelCallback(context, unit, type) {
    const risk = type == 'objects-summary' ? $('select[data-key="risk"]').val() : '';
    const label = context.dataset.label || '';

    let sourceValue = context.raw.toString(); //context.formattedValue == 0 ? context.raw.toString() : context.formattedValue;
    let value = formatNumber(parseFloat(sourceValue.replace(',', '')), risk) || '';

    value = (['human_death', 'individual'].includes(risk) && type == 'objects-summary') ? convertValueToScientificNotation(context.raw) : value;

    return `${label}: ${value} ${unit}`;
  }

  update(data, title) {
    this.chartObject.data.labels = data.labels;
    this.chartObject.data.datasets = data.datasets;
    
    if (title) this.chartObject.options.plugins.title.text = title;
    if (this.chartObject.options.scales.y) this.chartObject.options.scales.y.title.text = this.unit;

    this.chartObject.update();
  }

  clear() {
    this.chartObject.clear();
  }

  resize() {
    this.chartObject.resize();
  }

  exportToImage() {
    const image = this.chartObject.toBase64Image('image/png', 1);
    const link = document.createElement('a');
    const title = (Graph.project_title + '-' + this.fulltitle.trim()).replace(/(: )|(, )/gi, '-').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-zA-Z0-9\-]/g, '_').replace(/__/gi, '_');

    link.href = image;
    link.download = `${title}.jpg`;
    link.click();
  }
}

class ObjectsSummaryChart extends SingleChart {
  constructor(element, type, title = '') {
    super(element, type, title);

    this.configuration.options.scales = {
      y: {
        title: {
          display: true,
          text: '',
        },
        ticks: {
          callback: function (value, index, ticks) {
            const risk = $('select[data-key="risk"]').val();
            return ['human_death', 'individual'].includes(risk) ? convertValueToScientificNotation(value) : formatNumber(value, risk);
          }
        }
      }
    };

    this.chartObject = new Chart(
      this.element,
      {
        ...this.configuration,
        ...{
          type: 'bar',
          scales: {
            x: {
              stacked: true,
            },
            y: {
              stacked: true,
            }
          }
        }
      }
    );
  }

  update(data) {
    this.fulltitle = this.title + ': ' + $('[data-type="objects-summary"] [data-key="_danger"] option:selected').text().toLocaleLowerCase() + ', ' + $('[data-type="objects-summary"] [data-key="measure"] option:selected').text().toLocaleLowerCase() + ', ' + $('[data-type="objects-summary"] [data-key="risk"] option:selected').text().toLocaleLowerCase().replace(/\((.+?)\)/gi, '');

    super.update(data, this.fulltitle);
  }
}

function formatNumber(value, risk) {
  return risk != 'human_death' ? Intl.NumberFormat('de-CH', { style: 'currency', currency: 'CHF' }).format(value).replace('CHF', '').replace('.00', '') : value;
}

function convertValueToScientificNotation(value) {
  console.log(value, value == 0);
  if (value == 0) return value;

  const exponent = Math.floor(Math.log10(value));
  const mantissa = value / Math.pow(10, exponent);

  return `${mantissa.toFixed(2)}e${exponent}`;
}

class CostSummaryChart extends SingleChart {
  constructor(element, type, title = '') {
    super(element, type, title);

    this.configuration.options.scales = {
      y: {
        title: {
          display: true,
          text: '',
        },
        ticks: {
          callback: function (value, index, ticks) {
            return formatNumber(value);
          }
        }
      }
    };

    this.chartObject = new Chart(
      this.element,
      {
        ...this.configuration,
        ...{
          type: 'bar',
          scales: {
            x: {
              stacked: true,
            },
            y: {
              stacked: true
            }
          }
        }
      }
    );
  }
}

class CollectiveRiskChart extends SingleChart {
  constructor(element, type, title = '') {
    super(element, type, title);

    this.chartObject = new Chart(
      this.element,
      {
        ...this.configuration,
        ...{
          type: 'pie',
          scales: {
            x: {
              stacked: true,
            },
            y: {
              stacked: true
            }
          }
        }
      }
    );
  }

  update(data) {
    this.fulltitle = this.title + ': ' + $('[data-type="collective-risk"] [data-key="measure"] option:selected').text().trim().toLocaleLowerCase();
    
    super.update(data, this.fulltitle);
  }
}
